import { SubpageLayout2018 } from '../subpageLayout';

const members = [
  { name: '方保僑先生', title: '香港互動市務商會創會及榮譽會長', image: '/2018/images/judges_panel-1.jpg', id: 'member_1' },
  { name: '楊文銳先生, MH', title: '智慧城市聯盟副會長兼電子身分委員會主席', image: '/2018/images/judges_panel-2.jpg', id: 'member_2' },
  { name: '凌羽一博士', title: '香港市務學會主席', image: '/2018/images/judges_panel-3.jpg', id: 'member_3' },
  { name: '鄧兆星博士', title: '香港大學建築學院城市規劃及設計系客席副教授', image: '/2018/images/judges_panel-4.jpg', id: 'member_4' },
  { name: '朱偉傑先生', title: '香港零售科技商會會長\nThe Gravitas Group 創辦人及行政總裁', image: '/2018/images/judges_panel-5.jpg', id: 'member_5' },
  { name: '王春波醫生, JP', title: '香港電子健康聯盟主席\n香港醫療資訊學會會長', image: '/2018/images/judges_panel-6.jpg', id: 'member_6' },
  {
    name: 'DR. K F TSANG',
    title: 'Associate Professor, Department of Electronic Engineering, City University of Hong Kong',
    image: '/2018/images/judges_panel-7.jpg',
    id: 'member_7',
  },
];

export default function Judges2018Zh() {
  return (
    <SubpageLayout2018 lang="zh" title="評審" page="judges">
      <div className="para_introduction">
        <h1>評審</h1>
        <div className="center_introduction">
          <p className="p1"></p>
        </div>
        <div className="head_advisory_container">
          <div className="head_advisory_photo_container_responsive">
            <div className="head_advisory_photo">
              <img src="/2018/images/judge_head.jpg" alt="" />
            </div>
          </div>
          <div className="head_advisory_text_container animate" data-animate="slideInRight" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_subject" style={{ fontSize: 36, fontWeight: 'bold', marginBottom: 10 }}>評審主席</div>
            <div className="head_advisory_name">莫乃光議員, JP</div>
            <div className="head_advisory_text">
              莫乃光，是現任資訊科技界立法會議員，專業議政成員之一，從事資訊科技及電訊業二十多年。他積極為資訊及通訊科技界發聲，倡議在香港社會推動科技應用，是為人熟悉的資訊科技界領袖和互聯網先驅。
              <br /><br />
              莫乃光致力捍衛香港的核心價值。在貢獻業界之餘，亦擔任政府、醫管局、西九龍文化區管理局及大專院校等多個委員會委員。
              <br /><br />
              莫乃光畢業於美國普度大學，擁電腦及電機工程學士與電機工程碩士學位。
            </div>
          </div>
          <div className="head_advisory_photo_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_photo">
              <img src="/2018/images/judge_head.jpg" alt="" />
            </div>
          </div>
        </div>
        <div className="board_members_container_bg">
          <div className="board_members_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="board_members_subject" style={{ fontSize: 36, fontWeight: 'bold', marginBottom: 10 }}>其他評審</div>
            <div className="member_all">
              {members.map((m) => (
                <div className={`member ${m.id}`} id={m.id} key={m.id}>
                  <div className="member_photo">
                    <img src={m.image} alt="" />
                  </div>
                  <div className="member_text_container">
                    <div className="member_text_name" style={{ fontSize: 20, fontWeight: 'bold' }}>{m.name}</div>
                    <div className="member_text_title" style={{ fontSize: 16, fontWeight: 100, whiteSpace: 'pre-line' }}>{m.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

